import { observer } from "mobx-react";
import { renderToStaticMarkup } from 'react-dom/server'
import Currency from "../../../../../components/currency/currency";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./rma-action-change-return-method-confirm.scss";
import { IRmaActionStore } from "../../rma-types";
import { DefaultModalLayout } from "../../../../../components/modal/layouts/default-modal-layout";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import { Button } from "../../../../../components/inputs/button/button";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";

interface IProps {
    actionStore: IRmaActionStore;
    returnLabelFeeAmount?: number;
    paymentCurrencyCode: string;
    currentReturnMethodName: string;
    newReturnMethodName: string;
    switchToNoShipmentRequired: boolean;
}

const RmaActionChangeReturnMethodConfirm: React.FC<IProps> = observer(({
    actionStore,
    paymentCurrencyCode,
    currentReturnMethodName,
    returnLabelFeeAmount,
    newReturnMethodName,
    switchToNoShipmentRequired
}) => {
    const scope = 'dashboard-rma-card-popups';
    const { getTranslation } = useDashboardTranslation();
    const amountWithCurrency = renderToStaticMarkup(<Currency currencyCode={paymentCurrencyCode} amount={returnLabelFeeAmount} />);
    return (
        <DefaultModalLayout onCloseClicked={actionStore.resetReturnMethodChange} isCloseDisabled={false}>
            <div className="rma-action-change-return_method-confirm-modal">
                <div>
                    <FontBody1 color={FONT_COLOR.NEUTRAL3}>{ getTranslation('CHANGE_METHOD_TITLE', scope) }</FontBody1>
                </div>
                <div className="rma-action-change-return_method-confirm-modal-text">
                    <FontBody1 color={FONT_COLOR.PRIMARY3}>
                        <div className={'rma-action-change-return_method-confirm-modal-content'}>
                            {getTranslation('DESCRIPTION_LINE_1', scope, [currentReturnMethodName])} to {newReturnMethodName}. {getTranslation('DESCRIPTION_LINE_2', scope, [amountWithCurrency, currentReturnMethodName])}.
                            {switchToNoShipmentRequired && (<>
                                <br />
                                {getTranslation('DESCRIPTION_LINE_3', scope)} {newReturnMethodName} {getTranslation('DESCRIPTION_LINE_4', scope)}
                                <br />
                                {getTranslation('DESCRIPTION_LINE_5', scope, [newReturnMethodName])}
                                
                            </>)}
                            {!switchToNoShipmentRequired && (
                                <>
                                    <br />
                                    {getTranslation('DESCRIPTION_LINE_6', scope, [newReturnMethodName])}
                                </>
                            )}
                        </div>
                    </FontBody1>
                </div>
                <div className="rma-action-change-return_method-confirm-modal-buttons">
                    <Button text={getTranslation('REMOVE_FEE', scope)}
                            onClick={actionStore.confirmReturnMethodsChangeWithoutLabelFees}
                            variant={BUTTON_VARIANTS.Tertiary}
                            hasLoader={true}
                            isLoading={false} />
                    <Button text={getTranslation('APPLY_FEE', scope)}
                            onClick={actionStore.confirmReturnMethodsChangeWithLabelFees}
                            variant={BUTTON_VARIANTS.Primary}
                            hasLoader={true}
                            isLoading={false} />
                </div>
            </div>
        </DefaultModalLayout>
    )
});

export default RmaActionChangeReturnMethodConfirm;